<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>

<!-- STATUS APROVAR -->
@if (alertInconsistencia === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/inconsistencia.png" alt="representando inconsistência na operação" width="82px">
      <p class="titulo-alert mt-4 c-warning"> {{ alertInconsistenciaSubtitulo }} </p>
      <div class="footer-alert">
        <p class="subtitulo-alert bg-warning"> {{ alertInconsistenciaMensagem }} </p>
        <button class="btn-borda-branca bnt-font3 btn-grande3 mt-3" (click)="fecharAlertInconsistencia()">SAIR</button>
      </div>
    </div>
  </div>
}

@if (alertSucesso === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" alt="representando sucesso na operação" width="82px">
      <p class="titulo-alert mt-4"> {{ alertSucessoSubtitulo }} </p>
      <div class="footer-alert">
        <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
        <button class="botao-secundario-outline mt-3" (click)="fecharAlertSucesso()">SAIR</button>
      </div>
    </div>
  </div>
}

@if (erro === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" alt="representando erro na consulta de pedidos pós pago" width="82px">
      <p class="titulo-alert titulo-alert-erro mt-4 c-danger"> {{ alertErroSubtitulo }} </p>
      <div class="footer-alert bg-danger">
        <p class="subtitulo-alert"> {{ alertErroMensagem }} </p>
        <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3" (click)="fecharAlertErro()">SAIR</button>
      </div>
    </div>
  </div>
}

<!-- ALERT INSERIR SENHA -->
@if (showInserirSenha === true) {
  <div class="body-senha">
    <div class="div-senha-inserir">
      <p class="titulo-senha mb-5">Senha para liberação Pós-pago
        <button class="botao-setinha-voltar btn-icon" (click)="inserirSenhaFechou()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </button>
      </p>
      <div class="row ">
        <div class="col-7">
          <label class="label-menor" for="inptPassword">INSIRA SUA SENHA</label>
          <div class="d-flex align-items-center">
            <input [type]="hide ? 'password' : 'text'" class="form-control d-inline-block" id="inptPassword" placeholder="Senha" [(ngModel)]="senhaAtual">
            <button
              (click)="hide = !hide"
              (keydown.enter)="hide = !hide"
              class="btn-icon"
              >
              <i class="fa input-icon" [ngClass]="hide ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="col-5 align-self-end">
          <button class="botao" id="btnAprovar" (click)="postSenhaInsira()" [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosLiberarPedidosPosPago?.Alterar)">APROVAR</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ALERT CADASTRAR SENHA -->
@if (showCadastrarSenha === true) {
  <div class="body-senha">
    <form [formGroup]='form'>
      <div class="div-senha-cadastrar">
        <p class="titulo-senha mb-5">Cadastrar senha de liberação de pedido pós-pago
          <button class="botao-setinha-voltar btn-icon" (click)="cadastrarSenhaFechou()" >
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
        </p>
        <div class="row justify-content-between mx-1">
          <p class="label-menor">INSIRA AS INFORMAÇÕES</p>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="input-group align-items-center">
              <input formControlName="senhaAtual" type="password" class="form-control" placeholder="Senha Atual"
                id="senhaAtual" (blur)='senhasConferem()' (keyup)='replaceSenhaAtual()'>
              <button class="btn-icon" id="iconeOlho3" (click)="revelaEscondeSenhaAtual()">
                <i class="fa fa-eye c-black icone-olho" aria-hidden="true"></i>
              </button>
            </div>
            <div class="col-lg-6">
              <p class="descricaoSenha ms-3 text-nowrap"><strong class="vermelho">{{mensagemSenhaIguais}}</strong></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="input-group align-items-center">
              <input
                formControlName="senha"
                type="password"
                class="form-control"
                placeholder="Senha Nova"
                (blur)="forcaSenha()"
                (blur)="senhasConferem()"
                id="inputSenha"
                (keyup)="replace()"
                >
              <button
                id="iconeOlho"
                (click)="revelaEscondeSenha()"
                (keydown.enter)="revelaEscondeSenha()"
                class="btn-icon"
                >
                <i class="fa fa-eye c-black icone-olho" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="input-group align-items-center">
              <input
                formControlName="confirmarSenha"
                type="password"
                class="form-control"
                placeholder="Confirme sua Nova Senha"
                (blur)="senhasConferem()"
                id="confirmarSenha"
                (keyup)="replaceRepSenha()"
                >
              <button
                id="iconeOlho2"
                (click)="revelaEscondeSenhaConfirmar()"
                (keydown.enter)="revelaEscondeSenhaConfirmar()"
                class="btn-icon"
                >
                <i class="fa fa-eye c-black icone-olho" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- FORÇA DA SENHA -->
        <div class="row">
          <div class="col-lg-12">
            @if (forca > 0 && forca < 30) {
              <p class="ms-3 mt-2"><img class="me-1" src="/assets/img/senhaFraca.png" alt="representando que a senha está fraca"> {{senhaForca}}
              </p>
            }
            @if (forca >= 30 && forca < 50) {
              <p class="ms-3 mt-2"><img class="me-1" src="/assets/img/senhaMedia.png" alt="representando que a senha está média"> {{senhaForca}}
              </p>
            }
            @if (forca >= 50) {
              <p class="ms-3 mt-2"><img class="me-1" src="/assets/img/senhaForte.png" alt="representando que a senha está forte"> {{senhaForca}}
              </p>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <p> <strong class="descricaoSenha">{{informarCaracter}}</strong></p>
            <p><strong class="descricaoSenha">{{informarLetras}}</strong></p>
            <p><strong class="descricaoSenha">{{informarNumeros}}</strong></p>
            @if (informarCaracter == '' && informarLetras == '' && informarNumeros == '' ) {
              <p class="descricaoSenha ms-3">Use <strong class="verde">nove ou mais caracteres </strong> com uma
              combinação<br> de <strong class="verde"> letras, números e/ou símbolos.</strong></p>
            }
          </div>
          <div class="col-lg-6">
            <p class="descricaoSenha ms-3"><strong class="vermelho"> {{mensagemSenha}} </strong></p>
          </div>
        </div>
        <!-- BOTOES -->
        <div class="row mt-5 g-0 ms-150">
          <div class="col-auto me-3">
            <button class="botao-outline" (click)="cadastrarSenhaFechou()">VOLTAR</button>
          </div>
          <div class="col-auto">
            @if (forca >= 30 && confereSenha === true && form.status == 'VALID' && confereNumero === false && mensagemSenhaIguais == '') {
              <button type="button " class="botao" (click)='postSenha()'>ALTERAR MINHA SENHA</button>
            }
            @if (forca <= 30 || confereSenha === false || confereNumero === true || form.status == 'INVALID' || mensagemSenhaIguais == 'A senha atual e a senha nova são iguais' ) {
              <button type="button " class="botao disabled" disabled>ALTERAR MINHA SENHA</button>
            }
          </div>
        </div>
      </div>
      <div class="col-auto">
        @if (forca >= 30 && confereSenha === true && form.status == 'VALID' && confereNumero === false && mensagemSenhaIguais == '') {
          <button type="button " class="botao" (click)='postSenha()'>ALTERAR MINHA
          SENHA</button>
        }
        @if (forca <= 30 || confereSenha === false || confereNumero === true || form.status == 'INVALID' || mensagemSenhaIguais == 'A senha atual e a senha nova são iguais' ) {
          <button type="button " class="botao disabled" disabled>ALTERAR MINHA SENHA</button>
        }
      </div>
    </form>
  </div>
}


<div class="container py-4">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Listar pedidos pós-pago</h1>

        <!-- SELECIONAR EMPRESA -->
        <div class="row mt-5 mb-4">
          <div class="col-lg-4">
            <div>
              <app-select
                [value]="empresaSelecionada"
                name="empresaSelecionada"
                id="slctEmpresa"
                (change)="empresaSelecionada = $event.target.value"
                [options]="empresaSelecionadaOptions"
                defaultDescription="SELECIONAR EMPRESA"
                defaultValue="0"
                optionValue="value"
                optionText="description">
              </app-select>

            </div>
          </div>
          <button class="botao-secundario" id="btnFiltrar"
            [disabled]="empresaSelecionada == 0 || !('PedidosLiberarPedidosPosPago' | usuarioPermissao:'Imprimir' | async)"
            [ngClass]="{
              'disabled': empresaSelecionada == 0 || !('PedidosLiberarPedidosPosPago' | usuarioPermissao:'Imprimir' | async)
            }" (click)='filtrar()'>FILTRAR</button>

          @if (empresaSelecionada != 0 && ('PedidosLiberarPedidosPosPago' | usuarioPermissao:'Imprimir' | async)) {
            <button class="botao-outline ms-4"
              (click)="limparFiltro()">LIMPAR
            FILTRO</button>
          }

        </div>

        @if (listaPedidos == null) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" alt="representando que lista de pedidos está vazia" width="200px">
            <p class="legenda-erro">{{mensagemErro}}</p>
          </div>
        }

        <!-- TABELA -->
        @if (listaPedidos != null) {
          <div>
            <div class="table-hover table-responsive">
              <table class="table">
                <caption>Tabela com lista de pedidos</caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [(ngModel)]="selectAll"
                          [checked]="selectAllPed"
                          (change)="selectAllUserId($event)"
                          id="selectAllPedidos"
                          >
                        <label class="form-check-label" for="selectAllPedidos"></label>
                      </div>
                    </th>
                    <th scope="col">CNPJ</th>
                    <th scope="col">RAZÃO SOCIAL</th>
                    <th scope="col">PEDIDO</th>
                    <th scope="col">EMISSÃO</th>
                    <th scope="col">VALOR TOTAL</th>
                    <th scope="col">STATUS DE LIBERAÇÃO</th>
                    <th scope="col">TIPO DE PEDIDO</th>
                  </tr>
                </thead>
                <tbody>
                  @for (ped of listaPedidos; track ped; let i = $index) {
                    <tr>
                      <td class="align-middle">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="checkbox{{ i }}"
                            [checked]="isChecked(ped.idPedido)"
                            (change)="onTableAddressClick(ped.idPedido)"
                            name="checkPedidos"
                            [attr.aria-label]="'Selecionar pedido ' + ped.idPedido"
                            title="{{ped.idPedido}}"
                            >
                          <label class="form-check-label" for="checkbox{{ i }}"> </label>
                        </div>
                      </td>
                      <td class="align-middle"> {{ ped.cnpj | cnpj }} </td>
                      <td class="align-middle"> {{ ped.razaoSocial }} </td>
                      <td class="align-middle verde" [ngClass]="{ 'amarelo': this.listaPedidos[i].erroPedido }">
                        {{ ped.idPedido }}
                      </td>
                      <td class="align-middle"> {{ ped.dtEmissao | date:'dd/MM/yyyy' }} </td>
                      <td class="align-middle"> {{ ped.valorTotal | currency:'BRL' }} </td>
                      <td class="align-middle mt-2 " [ngClass]="{ 'amarelo': this.listaPedidos[i].erroPedido }"
                        [ngClass]="{ 'cardTable': this.listaPedidos[i].erroPedido }">
                      {{ped.statusFinanceiro}} </td>
                      <td class="align-middle"> {{ ped.tipoPedido }} </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <!-- APROVAR -->
            <div class="d-flex justify-content-center mt-4">
              <button class="botao-aprovar col-4" id="btnAprovar" (click)="aprovar()"
              [disabled]="!('PedidosListarPedidos' | usuarioPermissao:'Alterar' | async)" [ngClass]="{
              disabled: !('PedidosListarPedidos' | usuarioPermissao:'Alterar' | async)
            }">APROVAR</button>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
